import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

interface Props {
    children: React.ReactNode;
    authentication?: boolean;
    roles?: ("ADMIN" | "BROKER")[];
}

const AuthLayout = ({ children, authentication = true, roles = [] }: Props) => {
    const navigate = useNavigate();
    const { authUser, authToken, loading } = useAuth();
    const [checked, setChecked] = useState(false);

    const isAuthenticated = Boolean(authUser && authToken);

    useEffect(() => {
        if (loading) return;

        if (authentication && !isAuthenticated) {
            navigate("/broker/login");
            return;
        }

        if (!authentication && isAuthenticated) {
            if (authUser?.userType === "ADMIN") navigate("/admin/dashboard");
            else if (authUser?.userType === "BROKER") navigate("/broker/dashboard");
            else navigate("/");
            return;
        }

        if (authentication && roles.length > 0) {
            if (!roles.includes(authUser?.userType as any)) {
                if (authUser?.userType === "ADMIN") navigate("/admin/dashboard");
                else if (authUser?.userType === "BROKER") navigate("/broker/dashboard");
                else navigate("/");
                return;
            }
        }

        setChecked(true);
    }, [loading, authentication, isAuthenticated, roles, authUser, navigate]);

    if (!checked) return null;
    return <>{children}</>;
};

export default AuthLayout;
